export const employees = {
  id: "my-hr-create-employees-list-table",
  columns: [
    {
      id: "selected",
      label: "R",
      type: "radio",
      align: "center",
      width: "85px",
    },
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "fullname",
      type: "text",
      label: "OC_NAME",
      search: true,
      sort: true,
    },
    {
      id: "contractCode",
      type: "text",
      label: "MY_HR_GET_CONTRACT",
      search: false,
      sort: false,
    },
    {
      id: "dateOfBirth",
      type: "text",
      label: "MY_HR_DATE_OF_BIRTH",
      sort: true,
    },
    {
      id: "mothersfullname",
      type: "text",
      label: "MY_HR_MOTHERS_NAME",
      sort: true,
    },
  ],
};

export const employeesIsMobile = {
  id: "my-hr-create-employees-list-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "fullname",
      type: "text",
      label: "OC_NAME",
      search: true,
      sort: true,
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const users = {
  id: "my-hr-users-list-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "fullname",
      type: "text",
      label: "OC_NAME",
      sort: true,
      search: true,
    },
    {
      id: "dateOfBirth",
      type: "i18nDate",
      label: "MY_HR_DATE_OF_BIRTH",
      sort: true,
    },
    {
      id: "email",
      type: "text",
      label: "MY_HR_USER",
      sort: true,
      search: "true",
    },
    {
      id: "lastLogin",
      type: "text",
      label: "MY_HR_LAST_LOGIN",
      sort: true,
    },
    {
      id: "active",
      type: "checkbox",
      label: "OC_ACTIVE",
      align: "center",
      width: "85px",
    },
  ],
};

export const usersIsMobile = {
  id: "my-hr-users-list-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "fullname",
      type: "text",
      label: "OC_NAME",
      sort: true,
      search: true,
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const importErrors = {
  id: "my-hr-import-errors-table",
  //minWidth: "800px",
  columns: [
    {
      id: "selected",
      type: "text",
      label: "",
      width: "0.5%",
    },
    {
      id: "employeeName",
      type: "text",
      label: "OC_NAME",
      search: true,
    },
    {
      id: "contract",
      type: "text",
      label: "MY_HR_GET_CONTRACT",
      search: true,
    },
    {
      id: "employmentType",
      type: "text",
      label: "OC_NAME",
      search: true,
    },
    {
      id: "employee",
      type: "text",
      label: "MY_HR_EMPLOYEE_CODE",
      search: true,
    },
    {
      id: "error",
      type: "importError",
      label: "OC_ERROR",
    },
  ],
};

export const importErrorsDef = {
  id: "my-hr-import-errors-table",
  //minWidth: "800px",
  columns: [
    {
      id: "selected",
      type: "text",
      label: "",
      width: "0.5%",
    },
    {
      id: "employeeName",
      type: "text",
      label: "OC_NAME",
      search: true,
      width: "25%",
    },
    {
      id: "contract",
      type: "text",
      label: "MY_HR_GET_CONTRACT",
      search: true,
      width: "12%",
    },
    {
      id: "employmentType",
      type: "text",
      label: "MY_HR_EMPLOYMENT_TYPE",
      search: true,
      width: "15%",
    },
    {
      id: "employee",
      type: "text",
      label: "MY_HR_EMPLOYEE_CODE",
      search: true,
      width: "15%",
    },
    {
      id: "error",
      type: "importSSHRError",
      label: "OC_ERROR",
    },
  ],
};

export const importErrorsDefIsMobile = {
  id: "my-hr-import-errors-table",
  select: "row",
  columns: [
    {
      id: "selected",
      type: "text",
      label: "",
      width: "0.5%",
    },
    {
      id: "employeeName",
      type: "text",
      label: "OC_NAME",
      search: true,
    },
    {
      id: "contract",
      type: "text",
      label: "MY_HR_GET_CONTRACT",
      search: true,
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const massRoleErrors = {
  id: "my-hr-add-mass-roles-errors-table",
  select: "row",
  columns: [
    {
      id: "selected",
      type: "text",
      label: "",
      width: "0.5%",
    },
    {
      id: "employeeName",
      type: "text",
      label: "OC_NAME",
      search: true,
      width: "25%",
    },
    {
      id: "contract",
      type: "text",
      label: "MY_HR_GET_CONTRACT",
      search: true,
      width: "12%",
    },
    {
      id: "employmentType",
      type: "text",
      label: "MY_HR_EMPLOYMENT_TYPE",
      search: true,
      width: "15%",
    },
    {
      id: "employee",
      type: "text",
      label: "MY_HR_EMPLOYEE_CODE",
      search: true,
      width: "15%",
    },
    {
      id: "error",
      type: "importError",
      label: "OC_NOTE",
    },
  ],
};

export const massRoleErrorsIsMobile = {
  id: "my-hr-add-mass-roles-errors-table",
  select: "row",
  columns: [
    {
      id: "selected",
      type: "text",
      label: "",
      width: "0.5%",
    },
    {
      id: "employeeName",
      type: "text",
      label: "OC_NAME",
      search: true,
    },
    {
      id: "contract",
      type: "text",
      label: "MY_HR_GET_CONTRACT",
      search: true,
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const removeMassRoleErrors = {
  id: "my-hr-remove-mass-roles-errors-table",
  //minWidth: "800px",
  columns: [
    {
      id: "selected",
      type: "text",
      label: "",
      width: "0.5%",
    },
    {
      id: "employeeName",
      type: "text",
      label: "OC_NAME",
      search: true,
      width: "25%",
    },
    {
      id: "contract",
      type: "text",
      label: "MY_HR_GET_CONTRACT",
      search: true,
      width: "12%",
    },
    {
      id: "module",
      type: "text",
      label: "OC_MODULE",
      search: true,
      width: "15%",
    },
    {
      id: "role",
      type: "text",
      label: "OC_ROLE",
      search: true,
      width: "15%",
    },
    {
      id: "error",
      type: "importError",
      label: "OC_NOTE",
    },
  ],
};

export const removeMassRoleErrorsIsMobile = {
  id: "my-hr-remove-mass-roles-errors-table",
  select: "row",
  columns: [
    {
      id: "selected",
      type: "text",
      label: "",
      width: "0.5%",
    },
    {
      id: "employeeName",
      type: "text",
      label: "OC_NAME",
      search: true,
    },
    {
      id: "contract",
      type: "text",
      label: "MY_HR_GET_CONTRACT",
      search: true,
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const allChangeRequests = {
  id: "my-hr-all-change-requests-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "name",
      type: "text",
      label: "OC_NAME",
      sort: true,
      search: true,
      align: "left",
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
      sort: true,
    },
    {
      id: "jobClass",
      type: "text",
      label: "MY_HR_JOB_CLASS",
      sort: true,
    },
    {
      id: "requestCount",
      type: "myHRBadges",
      label: "OC_REQUEST",
      width: "120px",
    },
  ],
};

export const allChangeRequestsIsMobile = {
  id: "my-hr-all-change-requests-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "52px",
    },
    {
      id: "name",
      type: "text",
      label: "OC_NAME",
      sort: true,
      search: true,
      align: "left",
    },
    {
      id: "requestCount",
      type: "myHRBadges",
      label: "OC_REQUEST",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const taxCreditApplicationRequests = {
  id: "my-hr-tax-credit-application-requests-table",
  select: "row",
  columns: [
    {
      id: "type",
      type: "taxDeclarationType",
      label: "MY_TAX_SUBMITTED_APPLICATIONS",
      align: "left",
    },
    {
      id: "state",
      type: "taxState",
      label: "OC_STATE",
      align: "center",
      width: "120px",
    },
    {
      id: "createdAt",
      type: "i18nDate",
      label: "MY_TAX_CREDIT_REQUEST_CREATED_AT",
      align: "center",
      width: "140px",
    },
  ],
};

export const taxCreditApplicationRequestsIsMobile = {
  id: "my-hr-tax-credit-application-requests-table",
  select: "row",
  columns: [
    {
      id: "type",
      type: "taxDeclarationType",
      label: "MY_TAX_SUBMITTED_APPLICATIONS",
      align: "left",
    },
    {
      id: "state",
      type: "taxState",
      label: "OC_STATE",
      align: "center",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const addMassRoleEmployeeList = {
  id: "my-hr-add-mass-role-employees-list-table",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "fullname",
      type: "text",
      label: "OC_NAME",
      search: false,
      sort: false,
    },
    {
      id: "contract",
      type: "text",
      label: "MY_HR_GET_CONTRACT",
      search: false,
      sort: false,
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
      sort: false,
    },
    {
      id: "jobClass",
      type: "text",
      label: "MY_HR_JOB_CLASS",
      sort: false,
    },
  ],
};

export const addMassRoleEmployeeListIsMobile = {
  id: "my-hr-add-mass-role-employees-list-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "fullname",
      type: "text",
      label: "OC_NAME",
      search: false,
      sort: false,
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const removeMassRoleEmployeeList = {
  id: "my-hr-remove-role-employees-list-table",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "fullname",
      type: "text",
      label: "OC_NAME",
      search: false,
      sort: false,
    },
    {
      id: "contract",
      type: "text",
      label: "MY_HR_GET_CONTRACT",
      search: false,
      sort: false,
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
      sort: false,
    },
    {
      id: "jobClass",
      type: "text",
      label: "MY_HR_JOB_CLASS",
      sort: false,
    },
  ],
};

export const removeMassRoleEmployeeListIsMobile = {
  id: "my-hr-remove-role-employees-list-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "fullname",
      type: "text",
      label: "OC_NAME",
      search: false,
      sort: false,
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const sendGroupPasswordEmployeeList = {
  id: "my-hr-send-group-passord-employees-list-table",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "fullname",
      type: "text",
      label: "OC_NAME",
      search: false,
      sort: false,
    },
    {
      id: "contract",
      type: "text",
      label: "MY_HR_GET_CONTRACT",
      search: false,
      sort: false,
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
      sort: false,
    },
    {
      id: "jobClass",
      type: "text",
      label: "MY_HR_JOB_CLASS",
      sort: false,
    },
  ],
};

export const sendGroupPasswordEmployeeListIsMobile = {
  id: "my-hr-send-group-passord-employees-list-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "fullname",
      type: "text",
      label: "OC_NAME",
      search: false,
      sort: false,
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const inactiveGroupEmployeeList = {
  id: "my-hr-inactive-group-employees-list-table",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "fullname",
      type: "text",
      label: "OC_NAME",
      search: false,
      sort: false,
    },
    {
      id: "contract",
      type: "text",
      label: "MY_HR_GET_CONTRACT",
      search: false,
      sort: false,
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
      sort: false,
    },
    {
      id: "jobClass",
      type: "text",
      label: "MY_HR_JOB_CLASS",
      sort: false,
    },
  ],
};

export const inactiveGroupEmployeeListIsMobile = {
  id: "my-hr-inactive-group-employees-list-table",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "fullname",
      type: "text",
      label: "OC_NAME",
      search: false,
      sort: false,
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};
